import template from './banktxes.html';
import controller from './banktxes.controller';

let bankTxesComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default bankTxesComponent;
